// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IdentificationDataSelectionForm_selectContainer__W7c5S {
  height: 90px;
}`, "",{"version":3,"sources":["webpack://./src/dashboard/components/IdentificationDataSelectionForm/IdentificationDataSelectionForm.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF","sourcesContent":[".selectContainer {\n  height: 90px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectContainer": `IdentificationDataSelectionForm_selectContainer__W7c5S`
};
export default ___CSS_LOADER_EXPORT___;
